export default {"src":"/_next/static/media/cloud.accb6803.svg","height":59,"width":53,"blurWidth":0,"blurHeight":0};